export const config = () => [
  {
    name: "message",
    selector: (row) => row.message,
    sortable: true,
    filterable: true,
  },
  {
    name: "Date",
    selector: (row) => row.date,
    sortable: true,
    filterable: true,
  },
];
